import React from 'react'
import { Button, Typography } from '@material-ui/core'
import TaskRow from './TaskRow'

const STATUS_ORDER = ['in_progress', 'blocked', 'needs_review', 'not_started', 'complete']

const TaskList = ({ tasks, onEdit, onStatusChange }) => {
  const [showComplete, setShowComplete] = React.useState(false)

  const sorted = [...tasks].sort((a, b) => {
    return STATUS_ORDER.indexOf(a.status) - STATUS_ORDER.indexOf(b.status)
  })

  const incomplete = sorted.filter(t => t.status !== 'complete')
  const complete = sorted.filter(t => t.status === 'complete')

  return (
    <div>
      {incomplete.length === 0 && complete.length === 0 && (
        <Typography variant="body2" color="textSecondary" style={{ padding: '8px 0' }}>
          No tasks yet.
        </Typography>
      )}
      {incomplete.map(task => (
        <TaskRow key={task._id} task={task} onEdit={onEdit} onStatusChange={onStatusChange} />
      ))}
      {complete.length > 0 && (
        <div style={{ marginTop: 8 }}>
          <Button
            size="small"
            onClick={() => setShowComplete(!showComplete)}
            style={{ textTransform: 'none', fontSize: 11, color: '#999' }}
          >
            {showComplete ? 'Hide' : 'Show'} completed ({complete.length})
          </Button>
          {showComplete && complete.map(task => (
            <TaskRow key={task._id} task={task} onEdit={onEdit} onStatusChange={onStatusChange} />
          ))}
        </div>
      )}
    </div>
  )
}

export default TaskList
